import { Box, IconButton, Typography } from "@material-ui/core"
import { BlessingResponse, CreateGiftCardsOrderModel } from "api"
import { useIsDesktop } from "common/MediaQueries"
import moment from "moment"
import Image from "next/image"
import { useRouter } from "next/router"
import { MutableRefObject } from "react"
import styled from "styled-components"
import BackIcon from "../Icons/BackIcon"
import { usePurchaseContext } from "./PurchaseContext"

const StyledLabel = styled(Typography).attrs({ variant: "body1" })``
const StyledWrapper = styled(Box)`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: column;

    a {
      position: absolute;
    }
  }
  a {
    display: flex;
  }
  /* p {
    margin-right: 8px;
  } */
  img {
    border-radius: 10px;
  }
`

const StyledImageText = styled(Typography).attrs<{ $headingLevel: string }>(
  (p) => ({
    variant: p.$headingLevel,
  })
)<{ $name: boolean; $headingLevel?: string }>`
  font-size: 24px;
  text-align: right;
  margin-top: ${(p) => p.$headingLevel === "h2" && "10px"};

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: ${(p) => (p.$name ? "32px" : "50px")};
    font-weight: ${(p) => (p.$name ? "500" : "bold")};
    text-align: center;
    margin-top: 0px;
  }
`

const StyledPriceText = styled(Typography).attrs({
  variant: "h3",
  component: "p",
})`
  font-family: NarkisBlock;
  font-size: 40px;
  font-weight: bold;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 120%;
  letter-spacing: normal;
  margin-right: 0 !important;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 50px;
    line-height: 40px;
    margin-top: 10px;
  }
`

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  position: relative;

  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 27px;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
`

const StyledImageWrapper = styled(Box)`
  position: relative;
  top: -5px;

  ${(p) => p.theme.breakpoints.up("md")} {
    order: 1;
    top: -25px;
  }
`

const StyledImage = styled(Image)`
  object-fit: cover;
`

const StyledTextWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: start;

  ${(p) => p.theme.breakpoints.down("sm")} {
    order: 1;
    margin-right: 12px;
    align-items: right;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    padding-top: 40px;
  }
`

const StyledLine = styled.div`
  background: #e3e3e3;
  height: 1px;
  width: 50%;
  position: absolute;
  bottom: 10px;
`

const StyledLink = styled.div`
  display: flex;
  cursor: pointer;
  p {
    margin-right: 8px;
  }

  :hover {
    text-decoration: underline;
  }
`

const StyledIconBtn = styled(IconButton)`
  padding: 1px;
  position: relative;
  bottom: 2px;
`

const StyledSchedulerText = styled(Typography).attrs({ variant: "body1" })`
  font-size: 16px;
  font-family: NarkisBlock;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 20px;
    margin-top: 10px;
  }
`

const StyledDiscount = styled(Typography).attrs({ variant: "body1" })`
  font-family: NarkisBlock;
  font-size: 14px;
  font-weight: 100;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: right;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;
    line-height: 30px;
  }
`

type PreviewHeaderProps = {
  purchaseData: CreateGiftCardsOrderModel
  selectedMode: string
  giftCard: BlessingResponse
  giftCardPrice: number
  link: string
  backIconText: string
  scrollRef?: MutableRefObject<any>
  titlePrefix?: string
  schedulerType?: string
  addPercentage?: number
  discountPrice?: number
}

const AiPurchaseHeader = ({
  purchaseData,
  selectedMode,
  giftCard,
  giftCardPrice,
  link,
  backIconText,
  scrollRef,
  titlePrefix,
  schedulerType,
  addPercentage,
  discountPrice,
}: PreviewHeaderProps) => {
  const isDesktop = useIsDesktop()
  const router = useRouter()

  const { videoFile, setIsVideoApproved } = usePurchaseContext()

  const onGoBack = () => {
    router.push(link)
    if (videoFile) setIsVideoApproved(true)
  }

  const getfrequencyText = () => {
    const date = moment(purchaseData?.allowanceEndDateTime).format("DD/MM/YY")
    if (purchaseData.giftCardScheduleType === "Daily") {
      return `לכל יום עד ל- ${date}`
    }
    if (purchaseData.giftCardScheduleType === "Weekly") {
      return `לכל שבוע עד ל- ${date}`
    }
    if (purchaseData.giftCardScheduleType === "Monthly") {
      return `לכל חודש עד ל- ${date}`
    }
    if (purchaseData.giftCardScheduleType === "Yearly") {
      return `לכל שנה עד ל- ${date}`
    }
  }

  const isAiImage =
    typeof window !== "undefined" &&
    giftCard?.isAiImage &&
    localStorage.getItem("imageAiUrl") &&
    giftCard?.slug === JSON.parse(localStorage.getItem("slugAi"))

  const imageUrl = isAiImage
    ? JSON.parse(localStorage.getItem("imageAiUrl"))
    : giftCard?.image?.imageUrl

  const imageAlt = isAiImage ? "" : giftCard?.image?.imageUrl
  return (
    <StyledWrapper ref={scrollRef}>
      <StyledLink onClick={onGoBack}>
        <StyledIconBtn>
          <BackIcon />
        </StyledIconBtn>
        <StyledLabel>{backIconText}</StyledLabel>
      </StyledLink>

      <StyledBox>
        <StyledImageWrapper>
          <StyledImage
            src={imageUrl}
            alt={imageAlt}
            width={isDesktop ? "400px" : "188px"}
            height={isDesktop ? "440px" : "136px"}
          />
        </StyledImageWrapper>
        <StyledTextWrapper>
          <StyledImageText $headingLevel="h1" $name={false}>
            {titlePrefix}
            {giftCard?.name}
          </StyledImageText>
          <StyledImageText $headingLevel="h2" $name={true}>
            {selectedMode === "full"
              ? `ל${purchaseData.recipientName}`
              : "גיפטקארד אישי"}
          </StyledImageText>
          <StyledPriceText>₪{giftCardPrice}</StyledPriceText>
          {addPercentage && discountPrice && (
            <StyledDiscount>
              תשלום לאחר הנחה{" "}
              <span style={{ fontWeight: "bold" }}>- ₪{discountPrice}</span>
            </StyledDiscount>
          )}
          {schedulerType === "Allowance" && (
            <StyledSchedulerText>{getfrequencyText()}</StyledSchedulerText>
          )}
        </StyledTextWrapper>
        {isDesktop && <StyledLine />}
      </StyledBox>
    </StyledWrapper>
  )
}

export default AiPurchaseHeader
